import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const SoundOffOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function SoundOffOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path fillRule="evenodd" clipRule="evenodd" d="M14.147 2.505h-2l-2.96 2.63c-.99.88-2.28 1.37-3.61 1.37-3 0-5.43 2.43-5.43 5.43v.13c0 3 2.43 5.43 5.43 5.43 1.33 0 2.62.49 3.61 1.37l2.96 2.63h2V2.505Zm-2 2.68v13.65l-1.63-1.45a7.437 7.437 0 0 0-4.94-1.88c-1.82 0-3.43-1.54-3.43-3.43v-.13c0-1.89 1.54-3.43 3.43-3.43 1.89 0 3.58-.67 4.94-1.88l1.63-1.45Z" />
          <path d="M17.355 8.047 15.94 9.462l2.546 2.545-2.546 2.546 1.415 1.414 2.545-2.546 2.539 2.539 1.414-1.414-2.539-2.539 2.539-2.538-1.414-1.414-2.539 2.538-2.545-2.546Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default SoundOffOutlined;